import * as THREE from 'three';
import { Group, Vector3, InstancedMesh } from 'three';
import TWEEN from '@tweenjs/tween.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { scaleCarModel } from '@blade-sxp/map/utils/index';
class Car3dS extends Group {
    props;
    skeleton;
    isLoaded;
    currentVector3;
    disposeStatus;
    model;
    count = 0;
    tween;
    carInstance;
    preAngle = 0;
    standCarMap = new Map();
    carWidth; // 车宽
    carLength; // 车长
    constructor(data) {
        super();
        this.props = data;
        this.name = this.uuid;
        const loader = new GLTFLoader();
        this.isLoaded = false;
        this.disposeStatus = false;
        this.currentVector3 = new Vector3(1, 0, 0);
        this.count = data.list.length;
        data.list.map((item) => {
            const { vertices, direction } = item.renderProps;
            this.standCarMap.set(item.id, {
                vertices: vertices,
                direction: direction,
                position: item.position,
            });
        });
        loader.load('/Mod_Car-0926.gltf', (gltf) => {
            this.model = gltf.scene.getObjectByName('Mod_Car');
            // this.model.rotation.x = 0;
            const box = new THREE.Box3().setFromObject(this.model);
            const size = box.getSize(new THREE.Vector3());
            this.carWidth = size.z;
            this.carLength = size.x;
            this.model.traverse((object) => {
                if (object.isMesh) {
                    object.material.transparent = true;
                    object.material.depthTest = true;
                    object.material.emissive.set('black');
                    object.material.opacity = 1;
                }
            });
            this.carInstance = new InstancedMesh(this.model.geometry, this.model.material, this.count);
            let index = 0;
            this.standCarMap.forEach((item) => {
                this.model.position.set(item.position.x, item.position.y, item.position.z);
                this.updateCarAngle(item.direction);
                this.scaleModel(item.vertices);
                this.model.updateMatrix();
                this.carInstance?.setMatrixAt(index, this.model.matrix);
                index++;
            });
            this.carInstance.instanceMatrix.needsUpdate = true;
            this.model.visible = false;
            this.add(this.carInstance);
            this.isLoaded = true;
        });
    }
    update(data) {
        const removeList = [];
        const list = data.list;
        const _standCarMap = new Map();
        list.map((item) => {
            const { vertices, direction } = item.renderProps;
            _standCarMap.set(item.id, {
                vertices: vertices,
                direction: direction,
                position: item.position,
            });
        });
        this.standCarMap.forEach((value, key) => {
            if (!_standCarMap.has(key)) {
                removeList.push({ ...value });
            }
        });
        this.standCarMap = _standCarMap;
        if (this.isLoaded) {
            if (this.count !== this.standCarMap.size) {
                this.count = this.standCarMap.size;
                this.carInstance.geometry.dispose();
                this.carInstance.material?.dispose();
                this.carInstance.dispose();
                this.remove(this.carInstance);
                this.carInstance = new InstancedMesh(this.model.geometry, this.model.material, this.count);
                this.add(this.carInstance);
            }
            let index = 0;
            this.standCarMap.forEach((item) => {
                this.model.position.set(item.position.x, item.position.y, item.position.z);
                this.updateCarAngle(item.direction);
                this.scaleModel(item.vertices);
                this.model.updateMatrix();
                this.carInstance?.setMatrixAt(index, this.model.matrix);
                index++;
            });
            this.carInstance.instanceMatrix.needsUpdate = true;
            if (removeList.length > 0) {
                const removeCarInstance = new InstancedMesh(this.model.geometry, this.model.material.clone(), removeList.length);
                this.add(removeCarInstance);
                let index = 0;
                removeList.map((item) => {
                    this.model.position.set(item.position.x, item.position.y, item.position.z);
                    this.updateCarAngle(item.direction);
                    this.scaleModel(item.vertices);
                    this.model.updateMatrix();
                    removeCarInstance?.setMatrixAt(index, this.model.matrix);
                    index++;
                });
                removeCarInstance.instanceMatrix.needsUpdate = true;
                const tween = new TWEEN.Tween({
                    opacity: 1,
                })
                    .to({
                    opacity: 0,
                }, 1000)
                    .onUpdate((obj) => {
                    if (this.disposeStatus) {
                        tween.stop();
                        return;
                    }
                    removeCarInstance.material.opacity = obj.opacity;
                })
                    .onComplete(() => {
                    removeCarInstance.geometry.dispose();
                    removeCarInstance.material?.dispose();
                    removeCarInstance.dispose();
                    this.remove(removeCarInstance);
                })
                    .start();
            }
        }
    }
    updateCarAngle(direction) {
        const _direction = new THREE.Vector3(direction.x, 0, direction.z);
        if (_direction.length() === 0)
            return 0;
        const normalVector = new THREE.Vector3();
        normalVector.crossVectors(this.currentVector3, _direction); // 坐标平面法线
        const isReverse = normalVector.y > 0;
        const angle = this.currentVector3.angleTo(_direction);
        this.model.rotation.reorder('YXZ'); // 规定旋转顺序
        this.model.rotation.x = -Math.PI / 2;
        this.model.rotation.y = isReverse ? angle : -angle;
    }
    scaleModel(vertices) {
        const scale = scaleCarModel(vertices, this.carWidth, this.carLength);
        this.model?.scale.set(scale, scale, scale);
    }
    dispose() {
        const { onDestory } = this.props;
        this.disposeStatus = true;
        this.traverse(function (obj) {
            if (obj instanceof THREE.Mesh) {
                obj.geometry.dispose();
                obj.material.dispose();
            }
            else {
                if (obj.parent) {
                    obj?.parent.remove(obj);
                }
                obj.clear();
            }
        });
        this.parent?.remove(this);
        this.clear();
        if (onDestory && typeof onDestory === 'function') {
            onDestory(this);
        }
    }
}
export default Car3dS;
